export default function cleanId(id: string): string {
    return id.replace(/[\.&@+#%]/g, '_');
}
